import { TableOfContents } from "../../../../src/mdx-components/TableOfContents.js";
import * as React from 'react';
export default {
  TableOfContents,
  React
};